'use client';

import { useCouponId, useCouponIndices } from '@svenskaspelab/poolbetting/core/nextjs/coupon';
import { cn } from '@svenskaspelab/poolbetting/ui/utils';
import { type ReactNode } from 'react';

/**
 * Component that renders an empty event header for layout purposes.
 *
 * @returns Layout component that renders an empty event header
 */
export function CouponEventLayoutHeader(): ReactNode {
  const [couponId] = useCouponId();
  const couponIndices = useCouponIndices({ couponId });

  const hasMultipleCoupons = couponIndices.length > 1;

  return (
    <span className={cn(`mb-2 hidden h-15 rounded-l-md ${hasMultipleCoupons ? 'lg:block' : ''} bg-surface-elevated`)} />
  );
}
